import React from 'react';
import {withTheme, Div, H1, P, Img, A} from 'glamorous';

import logo from '../../viska@2x.png';
import iphone from './iphone.png';
import pixel from './pixel.png';
import content from './content';
import Video from './Video';
import GooglePlayBadge from './google-play-badge.svg';
import AppStoreBadge from './app-store-badge.svg';
import heart from './heart.svg';
import {ANDROID} from './platform';

const Mobile = ({onOpenModal, theme}) =>
  <Div
    width="100%"
    overflow="scroll"
    background={`linear-gradient(45deg, #FFB444, 30%, ${theme.baseColor})`}
  >
    <Div
      display="flex"
      justifyContent="center"
      alignItems="center"
      width="100%"
      marginTop="40px"
    >
      <Img width="120px" src={logo} />
    </Div>
    <Div padding="30px">
      <Div margin="0 auto" maxWidth="500px" color="#FFFFFF">
        <H1 fontFamily={theme.fontRegular} fontSize="28" lineHeight="1.2em">
          {content.title}
        </H1>
        <P fontFamily={theme.fontLight} lineHeight="1.6em">
          {content.body}
        </P>
        <Div
          marginTop="25px"
          display="flex"
          justifyContent="center"
          alignItems="center"
          flexWrap="wrap"
        >
          <Div marginTop="13px">
            <A href="http://apple.co/2saa65a" target="_blank">
              <Img marginRight="10px" src={AppStoreBadge} />
            </A>
            <A href="https://bit.ly/2rvr0Js" target="_blank">
              <Img src={GooglePlayBadge} />
            </A>
          </Div>
        </Div>
        <Div
          position="relative"
          margin="50px auto"
          marginBottom="190%"
          width="80%"
          maxWidth="350px"
        >
          <Img
            position="absolute"
            width="100%"
            src={ANDROID ? pixel : iphone}
          />
          {ANDROID
            ? <Div
                left="6%"
                marginTop="21.6%"
                width="87.5%"
                position="absolute"
              >
                <Video autoPlay controls />
              </Div>
            : <Div
                left="7.4%"
                marginTop="26.5%"
                width="85.4%"
                position="absolute"
              >
                <Video autoPlay controls />
              </Div>}
        </Div>
        <Div
          fontSize="12px"
          fontFamily={theme.fontLight}
          color="#FFFFFF"
          textAlign="center"
          marginTop="50px"
        >
          <Div marginBottom="5px">
            Made with
            {' '}
            <Img width="1em" src={heart} />
            {' '}
            in Iceland
          </Div>
          <A
            textDecoration="none"
            color="#FFFFFF"
            href="mailto://hello@viska.com"
          >
            hello@viska.com
          </A>
          <Div marginTop="5px">
            Supported by
            {' '}
            <Img width="6em" src={require('./rannis.png')} />
            {' '}
          </Div>
        </Div>
      </Div>
    </Div>
  </Div>;

export default withTheme(Mobile);



// WEBPACK FOOTER //
// ./src/pages/Landing/Mobile.js